import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { ISocialProjectExperience } from '@src/types/resumeDetail/socialType';
import { ICampusProjectExperience } from '@/src/types/resumeDetail/campusType';

import './index.scss';

interface IProps {
  type: string;
  data: ISocialProjectExperience[] | ICampusProjectExperience[];
  setMode: Function;
}

const ProjectExperienceView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;
  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('project_experience_edit');
  };

  return (
    <div className="project_experience_view model_view">
      <div className="model_title">
        <div>项目经历</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {/* @ts-ignore */}
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          <div className="model_top">
            <div className="project_name">{item.projectName}</div>
            <div className="project_time">
              {dayjs(item.startDate).isValid() ? dayjs(item.startDate).format('YYYY/MM') : ''}-
              {/* eslint-disable-next-line no-nested-ternary */}
              {item.endDate === 253370736000000
                ? '至今'
                : dayjs(item.endDate).isValid()
                  ? dayjs(item.endDate).format('YYYY/MM')
                  : ''}
            </div>
          </div>
          <div className="model_line" />
          <div className="model_bottom">
            {type === 'social' && (
              <div className="label">
                <div className="label_left">公司名称：</div>
                <div className="label_right">{item.companyName}</div>
              </div>
            )}

            <div className="label">
              <div className="label_left">项目角色：</div>
              <div className="label_right">{item.projectPosition}</div>
            </div>
            <div className="label">
              <div className="label_left">项目描述：</div>
              <div className="label_right">{item.projectDescription || '-'}</div>
            </div>
            <div className="label label_last">
              <div className="label_left">项目链接：</div>
              <div className="label_right">
                {item.projectUrl ? <a href={item.projectUrl}>{item.projectUrl}</a> : '-'}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectExperienceView;
